import React, { useState, useCallback, useContext, createContext } from 'react';
import Toast from './Toast';

// Criar contexto para o Toast
const ToastContext = createContext({
  showToast: () => {}
});

/**
 * Hook para usar o Toast em qualquer componente
 * @returns {Object} Objeto com função showToast
 */
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast deve ser usado dentro de um ToastProvider');
  }
  return context;
};

/**
 * Provider que gerencia os toasts da aplicação
 * @param {Object} props - Propriedades do componente
 * @param {ReactNode} props.children - Componentes filhos
 * @returns {JSX.Element} Provider React
 */
export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  
  // Função para mostrar um toast
  const showToast = useCallback((message, type = 'success', duration = 3000) => {
    if (!message) return;
    
    const id = Date.now().toString();
    setToasts(prev => [...prev, { id, message, type, duration }]);
    return id;
  }, []);
  
  // Função para remover um toast
  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  }, []);
  
  // Valor do contexto
  const contextValue = { showToast };
  
  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </ToastContext.Provider>
  );
};

export default { ToastProvider, useToast };
